export enum BankAccountOnboardingState {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
}

export enum BankEligibilityStatus {
  ELIGIBLE = 'ELIGIBLE',
  INELIGIBLE = 'INELIGIBLE',
  REQUIRES_ADDITIONAL_ONBOARDING = 'REQUIRES_ADDITIONAL_ONBOARDING',
}

export enum BankEligibilityStep {
  OWNERS_ADDRESS_DETAILS_EU = 'OWNERS_ADDRESS_DETAILS_EU',
}

export enum BankEligibilityDocumentType {
  PROOF_OF_ADDRESS = 'PROOF_OF_ADDRESS',
}

export enum BankEligibilityDocumentState {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
}

export type BankEligibilityDocument = {
  documentType: BankEligibilityDocumentType
  fileName: string
  displayableName: string
}

export type BankEligibilityAddress = {
  street: string
  city: string
  postcode: string
  state: string
  countryCode: string
}

export type BankEligibilityBeneficialOwner = {
  id: string
  firstName: string
  lastName: string
  secondLastName: string
  email: string
  address: BankEligibilityAddress
  document?: BankEligibilityDocument
}

export type BankEligibility = {
  status: BankEligibilityStatus
  currentStepDetails: {
    step: BankEligibilityStep
    state: BankEligibilityDocumentState
    data: {
      businessId: string
      beneficialOwners: BankEligibilityBeneficialOwner[]
    }
  }
}

export type BankEligibilityOnboardingState = {
  id: string
  businessId: string
  state: BankAccountOnboardingState
  accountType: string
  provider: string
}
